// Screen 3 — Main goal (wizard step 2 of 9)
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { WizardScreen } from '../../components/planner/WizardScreen';
import { FieldError } from '../../components/planner/FieldError';
import { useDraft, STEP_ROUTES } from '../../lib/plannerDraft';
import { HEALTH_GOALS } from '../../lib/plannerRules';

export default function Step3Goal() {
  const nav = useNavigate();
  const { draft, patch, bump } = useDraft();
  const [showErr, setShowErr] = useState(false);

  const valid = Boolean(draft.health_goal);

  const onContinue = () => {
    if (!valid) { setShowErr(true); return; }
    bump(3);
    nav(STEP_ROUTES[3]);
  };

  return (
    <WizardScreen
      step={2}
      eyebrow="Your goal"
      title="What is your main goal?"
      canContinue={valid}
      onContinue={onContinue}
    >
      <div role="radiogroup" aria-label="Main goal" className="grid gap-3">
        {HEALTH_GOALS.map((g) => {
          const selected = draft.health_goal === g.id;
          return (
            <button
              key={g.id}
              type="button"
              role="radio"
              aria-checked={selected}
              onClick={() => patch({ health_goal: g.id }, { recompute: true, invalidateGeneration: true })}
              className="text-left p-4 md:p-5 transition-colors"
              style={{
                background: selected ? 'rgba(239,104,32,0.08)' : '#fff',
                border: selected
                  ? '2px solid var(--orange)'
                  : '1.5px solid var(--line)',
                borderRadius: 'var(--radius)',
              }}
              data-testid={`goal-${g.id}-btn`}
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div
                    className="font-display uppercase"
                    style={{ fontSize: '20px', letterSpacing: '0.06em' }}
                  >
                    {g.label}
                  </div>
                  <div className="mt-1 text-sm" style={{ color: 'var(--text-dim)' }}>
                    {g.blurb}
                  </div>
                </div>
                <span
                  aria-hidden
                  className="mt-1 shrink-0"
                  style={{
                    width: 20,
                    height: 20,
                    borderRadius: '50%',
                    background: selected ? 'var(--orange)' : 'transparent',
                    border: selected
                      ? '2px solid var(--orange)'
                      : '2px solid var(--line)',
                  }}
                />
              </div>
            </button>
          );
        })}
      </div>
      <FieldError id="goal-error">
        {showErr && !valid ? 'Please select a goal.' : null}
      </FieldError>
      <p className="mt-4 text-xs" style={{ color: 'var(--text-dim)' }}>
        Estimates only — this is not medical advice.
      </p>
    </WizardScreen>
  );
}
